/**
 * Translate description: Table header sort
 */

import Link from '@mui/joy/Link';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

export default function TableHeaderSort({
    children,
    sort,
    order,
    setSort,
    setOrder,
    sortBy,
    sortable
}) {
    if(!sortable){
        return children
    }
    return (<Link
        underline="none"
        color="primary"
        component="button"
        onClick={() => {
            if (sort !== sortBy) {
                setSort(sortBy);
                setOrder(false)
            } else {
                setOrder((prev)=>!prev)
            }
        }}
        fontWeight="lg"
        endDecorator={sort === sortBy ? <ArrowDropDownIcon /> : ''}
        sx={{
            '& svg': {
                transition: '0.2s',
                transform:
                    order ? 'rotate(0deg)' : 'rotate(180deg)',
            },
        }}
    >
        {children}
    </Link>)
}